import { IApiBaseResponse } from '~/utils/interface/common';
import axiosClient from './axiosClient';
import {
  IBodyAuthenticate,
  IResponseGetAuthUrl,
  IResponseGetQuickbookCustomer,
  IResponseGetQuickbookItem,
} from '~/utils/interface/quickbook';
import { IQuickbook } from '~/utils/interface/quickbook';

const quickbookApi = {
  getAuthUrl() {
    return axiosClient.get<IApiBaseResponse<IResponseGetAuthUrl>>('/api/admin/quickbooks/auth-url');
  },
  authenticate(data: IBodyAuthenticate) {
    return axiosClient.post<IApiBaseResponse<{}>>('/api/admin/quickbooks/authenticate', data);
  },
  getQuickbook() {
    return axiosClient.get<IApiBaseResponse<IQuickbook>>('/api/admin/quickbooks/detail');
  },
  disconnect() {
    return axiosClient.post<IApiBaseResponse<{}>>('/api/admin/quickbooks/disconnect');
  },
  getQuickbookCustomers() {
    return axiosClient.get<IApiBaseResponse<IResponseGetQuickbookCustomer>>('/api/admin/quickbooks/customers');
  },
  getQuickbookItems() {
    return axiosClient.get<IApiBaseResponse<IResponseGetQuickbookItem>>('/api/admin/quickbooks/items');
  },
  updateQuickbook(data: IQuickbook) {
    return axiosClient.put<IApiBaseResponse<IQuickbook>>('/api/admin/quickbooks', data);
  },
};

export default quickbookApi;
